module.exports = __webpack_public_path__ + "img/logo.2bbb84a4.png";